/**
 * Opciones de Ciudad y Sector del alta de propiedad.
 *
 * Vivían dentro de PropertyLocation.tsx. Se sacan para que el select Y el cuerpo del
 * POST /properties lean la MISMA lista: el formulario guarda el `value` (santo_domingo)
 * pero la API y los listados necesitan el nombre legible («Santo Domingo»). Antes el
 * cuerpo mandaba el value crudo y toda propiedad quedaba con `city: "santo_domingo"`
 * (GH#1850, menor 1).
 *
 * Son nombres propios de lugares de RD: NO se traducen.
 */
export interface OpcionZona {
  value: string;
  label: string;
}

export const CIUDADES: OpcionZona[] = [
  { value: 'santo_domingo', label: 'Santo Domingo' },
  { value: 'santiago', label: 'Santiago' },
  { value: 'la_vega', label: 'La Vega' },
  { value: 'san_cristobal', label: 'San Cristóbal' },
  { value: 'puerto_plata', label: 'Puerto Plata' },
  { value: 'san_pedro_macoris', label: 'San Pedro de Macorís' },
  { value: 'la_romana', label: 'La Romana' },
  { value: 'barahona', label: 'Barahona' },
];

export const SECTORES: OpcionZona[] = [
  { value: 'sector_a', label: 'Sector A' },
  { value: 'sector_b', label: 'Sector B' },
  { value: 'sector_c', label: 'Sector C' },
  { value: 'centro', label: 'Centro' },
  { value: 'plaza_central', label: 'Plaza Central' },
  { value: 'zona_colonial', label: 'Zona Colonial' },
  { value: 'piantini', label: 'Piantini' },
  { value: 'naco', label: 'Naco' },
  { value: 'gazcue', label: 'Gazcue' },
];

/**
 * Nombre legible de un value de select. Si el value no está en la lista (dato viejo o
 * ya escrito a mano) se devuelve tal cual, sin inventar nada.
 */
export function etiquetaDe(opciones: OpcionZona[], valor: string | undefined | null): string | undefined {
  const v = typeof valor === 'string' ? valor.trim() : '';
  if (!v) return undefined;
  return opciones.find((o) => o.value === v)?.label ?? v;
}
